import Registration_conditions from './registration_conditions';


export default Registration_conditions;

export {
    Registration_conditions
}